import { memo, useMemo, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { CHART_TYPES } from '@shared/config'
import {
  LineChart,
  ScatterChart,
  BarChart,
  HorizontalBarChart,
} from '@shared/ui/charts'
import { NotchLoader } from '@shared/ui/loader'

import styles from './styles.module.scss'

const FCGraph = ({ type, data, xAxisFormat, yAxisUnit }) => {
  const { t } = useTranslation(['hints'])

  // const chartId = useId()

  const chartRef = useRef(null)

  //
  //

  const chartToRender = useMemo(() => {
    if (!data) {
      return (
        <div className="d-flex h-100 align-items-center justify-content-center">
          <NotchLoader size={35} />
        </div>
      )
    }

    if (data?.error) {
      return (
        <div className="d-flex h-100 align-items-center justify-content-center">
          <p>{t('chartLoadError')}</p>
        </div>
      )
    }

    //
    //

    let ChartComponent

    switch (type) {
      case CHART_TYPES.LINE:
        ChartComponent = (
          <LineChart ref={chartRef} data={data} yAxisUnit={yAxisUnit} />
        )
        break
      case CHART_TYPES.SCATTER:
        ChartComponent = <ScatterChart ref={chartRef} />
        break
      case CHART_TYPES.BAR:
        ChartComponent = <BarChart ref={chartRef} />
        break
      case CHART_TYPES.HORIZONTAL_BAR:
        ChartComponent = (
          <HorizontalBarChart
            ref={chartRef}
            data={data}
            xAxisFormat={xAxisFormat}
          />
        )
        break
      default:
        ChartComponent = null
        break
    }

    return ChartComponent
  }, [type, data, xAxisFormat, yAxisUnit, t])

  return <div className={styles.graphContainer}>{chartToRender}</div>
}

export const Graph = memo(FCGraph)
